import BaseParameterAction from './BaseParameterAction.js';

class RemoveAutomationBreakPointsAction extends BaseParameterAction {
    execute({automation, points}) {
        automation.removeBreakPoints(points);
    }

    undo({payload}) {
        let {automation, points} = payload;
        points.forEach(
            point =>
                automation.addBreakPoint(point.step, point.value, point.id));
    }
}

export default RemoveAutomationBreakPointsAction;
